import React from 'react';
import "../components/styles/CustomerCenterPage.css";
import { trackContactClick } from "../utils/analytics";

const CustomerCenterPage = () => {
    const sendKakaotalk = () => {
        window.open('http://pf.kakao.com/_xkVeGn/chat', '_blank', 'noopener');
    }

    const sendPhone = () => {
        trackContactClick("tel");
        window.location.href = "tel:01044147579";
    }

    const sendKakao = () => {
        trackContactClick("kakao");
        sendKakaotalk();
    }

    return (
        <div className="customer-center-page">
            <h2 className="title">언제어디서나 궁금한 내용을 물어보세요!</h2>
            <h1 className="main-title">고객센터</h1>

            <div className="inquiry-cards">
                <div className="inquiry-card kakao-card" role={"button"} onClick={sendKakao}>
                    <h3 className="inquiry-title">카카오톡 채널 상담</h3>
                    <p className="kakao-inquiry-time">월-금(공휴일제외) 10:00-22:00</p>
                    <button className="inquiry-button">문의하기 ➜</button>
                </div>

                <div
                    className="inquiry-card email-card"
                    role="button"
                    onClick={sendPhone}
                >
                    <h3 className="inquiry-title">전화 상담</h3>
                    <p className="email-inquiry-time">월-금(공휴일제외) 10:00-22:00</p>
                    <p>T. 010-4414-7579</p>
                    <button className="inquiry-button">문의하기 ➜</button>
                </div>

            </div>
        </div>
    );
};

export default CustomerCenterPage;
